import { useState } from "react";
import { updateSupport } from "../../../../../services/supports/supports";
import { showAlert } from "../../../../../main_components/alerts/alert_response";

interface UseResolutionProps {
  ticketData: any;
  onTicketUpdate?: (updatedTicket: any) => void;
  getCurrentTimestamp: () => string;
  setLoadingComments: (val: boolean) => void;
  setLoadingTicketDocuments: (val: boolean) => void;
  setIsSubmitting: (val: boolean) => void;
  notificationSystemRef: React.MutableRefObject<any>;
  setCurrentStatus: (status: string) => void;
}

export const useResolution = ({
  ticketData,
  onTicketUpdate,
  getCurrentTimestamp,
  setLoadingComments,
  setLoadingTicketDocuments,
  setIsSubmitting,
  notificationSystemRef,
  setCurrentStatus
}: UseResolutionProps) => {
  const [resolving, setResolving] = useState(false);
  const [resolvingLoading, setResolvingLoading] = useState(false);
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");

  const handleConfirmResolution = async (
    feedbackValue: string,
    feedbackIsValid: boolean
  ) => {
    if (rating === 0) {
      showAlert({
        msj: "Por favor selecciona una calificación.",
        status: false,
        notificationSystemRef,
      });
      return;
    }

    if (!feedbackIsValid || feedbackValue.trim() === "") {
      showAlert({
        msj: "Por favor escribe un comentario antes de enviar tu evaluación.",
        status: false,
        notificationSystemRef,
      });
      return;
    }

    setLoadingComments(true);
    setLoadingTicketDocuments(true);
    setResolvingLoading(true);
    setIsSubmitting(true);

    try {
      await updateSupport(ticketData.ticket, {
        status: "CLOSE",
        user_rate: rating,
        user_rate_comment: feedbackValue,
      });

      const updatedTimestamp = getCurrentTimestamp();

      onTicketUpdate?.({
        ...ticketData,
        status: "CLOSE",
        user_rate: rating,
        user_rate_comment: feedbackValue,
        last_update: updatedTimestamp,
      });

      setCurrentStatus("CLOSE"); 
      showAlert({
        msj: "¡Gracias por tu evaluación!",
        status: true,
        notificationSystemRef,
      });
    } catch (error: any) {
      console.error("Error enviando calificación:", error);
      showAlert({
        msj:
          error.response?.data?.errorMessage ||
          "Error al enviar la calificación.",
        status: false,
        notificationSystemRef,
      });
    } finally {
      setLoadingComments(false);
      setLoadingTicketDocuments(false);
      setResolvingLoading(false);
      setIsSubmitting(false);
      setResolving(false);
      setRating(0);
      setFeedback("");
    }
  };

  return {
    resolving,
    setResolving,
    resolvingLoading,
    rating,
    setRating,
    feedback,
    setFeedback,
    handleConfirmResolution,
    setResolvingLoading,
    setCurrentStatus
  };
};
